import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileItem } from '@authority-labs/api-interfaces';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OrdersService } from '../../../modules/orders/orders.service';
import { CommonService } from '../../services/common/common.service';
import { CreatePlannerDialogComponent } from '../planner-dialog/create-planner-dialog.component';
import { DirectoryFiles } from './directory-files.model';

@Component({
  templateUrl: './directory-dialog.component.html',
  styleUrls: ['./directory-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectoryDialogComponent {
  orderId: number;
  plansFiles$: Observable<FileItem[]>;
  selection: SelectionModel<FileItem>;
  filesIds: string[] = [];
  progress = true;

  constructor(
    public dialogRef: MatDialogRef<CreatePlannerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: DirectoryFiles,
    private commonService: CommonService,
    private ordersService: OrdersService
  ) {
    this.orderId = data.orderId;
    this.filesIds = data.filesIds;
    this.selection = new SelectionModel<FileItem>(data.multiple, []);

    this.plansFiles$ = this.ordersService
      .getPlans(this.orderId)
      .pipe(tap(() => (this.progress = false)));
  }

  isIgnored(id: string) {
    return this.filesIds.includes(id);
  }

  canApply(): boolean {
    return !this.selection.isEmpty();
  }

  applySelection(): void {
    if (this.selection.isMultipleSelection()) {
      this.dialogRef.close(this.selection.selected);
    } else {
      this.dialogRef.close(this.selection.selected[0]);
    }
  }

  viewFile(e: Event, fileId: string) {
    e.stopPropagation();
    this.commonService.viewFile(fileId);
  }
}
